<template>
    <div class="list-category">
        <div class="select-category">
            <v-select
                    :items="getCategories()"
                    label="Select category"
                    v-model="currentCategory"
                    @change="selectChange"
            ></v-select>
        </div>
        <div class="item">
            <v-layout row wrap>
                <v-flex v-for="(item, i) in images" :key="i" xs4 md4 d-flex>
                    <v-card flat tile class="d-flex relative">
                        <v-img
                                :src="getUrlSrc(item.src)"
                                :lazy-src="getUrlSrc(item.src)"
                                aspect-ratio="1"
                                class="img-item lighten-2"
                                @click="toggleImage(item.id)"
                                :class="selected.includes(item.id) ? 'active': ''"
                        >
                            <template v-slot:placeholder>
                                <v-layout fill-height align-center justify-center ma-0>
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                            </template>
                        </v-img>
                        <v-icon v-if="selected.includes(item.id)" color="red" class="checked-icon">verified_user
                        </v-icon>
                    </v-card>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<style scoped>
    .list-category {
        padding: 10px;
        font-family: Roboto, sans-serif;
    }

    .category-name {
        text-align: left;
        font-weight: 500;
        margin-bottom: 5px;
        text-transform: capitalize;
        font-size: 16px;
    }

    .item:first-child {
        margin-top: 0;
    }

    .item {
        margin-top: 1rem;
        padding-bottom: 1rem;
        border-bottom: 2px solid #ebebeb;
    }

    .img-item {
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 4px !important;
    }

    .img-item:hover {
        border: 2px solid #ebebeb;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }

    .img-item.active {
        border-color: #ebebeb;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }

    .checked-icon {
        position: absolute;
        top: 0;
        right: 0;
    }

    .relative {
        position: relative;
    }
</style>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        name: "GalleryImage",
        data() {
            return {
                items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
                value: 'Foo'
            }
        },
        computed: {
            ...mapState('gallery', [
                'categories',
                'selected',
            ])
            ,
            currentCategory: {
                set(value) {
                    this.$store.state.gallery.currentCategory = value;
                },
                get() {
                    return this.$store.state.gallery.currentCategory
                }
            },
            images: {
                get() {
                    return this.getCurrentImages().images;
                },
                set() {

                }
            }
        },
        methods: {
            ...mapGetters('gallery', [
                'getLengthSelected',
                'getCategories',
                'getCurrentImages'
            ]),
            ...mapActions('app', [
                'initSnackbar'
            ]),
            ...mapActions('gallery', [
                'setSelectImage',
                'checkDifferentCategory',
                'clearSelected'
            ]),
            getUrlSrc(src) {
                return require('../assets/' + src)
            },
            async toggleImage(imageId) {
                this.setSelectImage(imageId)
            },
            selectChange() {
                this.clearSelected()
            },
        },
        mounted() {
            this.clearSelected()
        }
    }
</script>
